"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const epic_react_common_1 = require("epic-react-common");
const seamless_immutable_1 = __importDefault(require("seamless-immutable"));
const epic_alt_utils_1 = require("epic-alt-utils");
let RedeemConfigStore = class RedeemConfigStore {
    constructor() {
        this.on('error', error => {
            console.error(error);
        });
        this.state = seamless_immutable_1.default({
            config: {}
        });
    }
};
RedeemConfigStore = __decorate([
    epic_alt_utils_1.seamlessImmutable,
    __metadata("design:paramtypes", [])
], RedeemConfigStore);
exports.default = epic_react_common_1.alt.createStore(RedeemConfigStore, 'RedeemConfigStore');
//# sourceMappingURL=RedeemConfigStore.js.map